import type { GiftPassBundle } from '@bonsai/shared';
import { ChevronRight } from 'lucide-react';

import { formatAbsoluteDate } from '../../../utils/relative-age';
import { bundleDiscountLabel, passCountLabel } from '../gift-pass-bundles-list-model';
import { GiftPassTagList } from '../tags/GiftPassTagList';

import { GiftPassBundlePromotedBadge } from './GiftPassBundlePromotedBadge';
import { GiftPassBundleStatusPill } from './GiftPassBundleStatusPill';

import './gift-pass-bundles-list.css';

export function GiftPassBundleCardContent({
  bundle,
  showChevron,
}: {
  bundle: GiftPassBundle;
  showChevron: boolean;
}) {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <span className="gpb-name" style={{ fontSize: 15, fontWeight: 800 }}>
            {bundle.name}
          </span>
          {bundle.isPromoted && <GiftPassBundlePromotedBadge />}
        </div>
        <span className="nb-tabular gpb-card-discount">{bundleDiscountLabel(bundle)}</span>
      </div>
      <div
        className="nb-tabular"
        style={{ fontSize: 12.5, color: 'var(--nb-muted)', marginTop: 4 }}
      >
        {passCountLabel(bundle.passCount)}
      </div>
      {bundle.tags.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <GiftPassTagList tags={bundle.tags} />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 10,
          paddingTop: 10,
          borderTop: '1px solid var(--nb-border)',
        }}
      >
        <GiftPassBundleStatusPill isActive={bundle.isActive} />
        <span style={{ flex: 1, fontSize: 11.5, color: 'var(--nb-subtle)' }}>
          Updated {formatAbsoluteDate(bundle.updatedAt)}
        </span>
        {showChevron && <ChevronRight size={14} aria-hidden style={{ color: 'var(--nb-faint)' }} />}
      </div>
    </>
  );
}
